import { render } from "./LabPaid.vue?vue&type=template&id=2de53ae7"
import script from "./LabPaid.vue?vue&type=script&lang=js"
export * from "./LabPaid.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__